import gql from 'graphql-tag';

/**
 * Data of the block project-acceptance-report-approval ("Abnahmeprotokoll: Freigabe"): the approval
 * state and the top-level note `acceptanceApprovementNote`. Read through
 * `Project.blocks.acceptanceReportApproval`, which checks the block's read permission.
 */
export const PROJECT_ACCEPTANCE_REPORT_APPROVAL_FIELDS = gql`
  fragment projectAcceptanceReportApprovalFields on ProjectAcceptanceReportApprovalBlock {
    id
    number
    acceptanceApprovementVerificationState
    acceptanceApprovementNote
  }
`;
